import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Card } from '../../../components/Card';
import { ParentToSub, Times } from '../../../components/Icon';
import { Modal, ModalControls } from '../../../components/Modal';
import { deleteParentCompanyFromCompany, deleteSubCompanyFromCompany } from '../actions';
import { CompanyLabel } from './CompanyLabel';
import { CompanyStructureSelection } from './CompanyStructureSelection';

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }
  .sub-company {
    .delete {
      opacity: 0;
    }
    &:hover {
      .delete {
        opacity: 1;
      }
    }
  }

  .box.sub {
    margin-left: 20px;
  }
`;

const STATE = {
  edit: false,
  deleteSubCompany: false,
  deleteParentCompany: false,
};
/* eslint-disable react/prefer-stateless-function */
class CompanyStructureCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  get company() {
    return this.props.company;
  }

  render() {
    const company = this.props.company;
    return (
      <Card className="company-info-card info-card data">
        <Container>
          <HBox>
            <h2>{this.lbl('company.info.structure.title')}</h2>
            <div onClick={this.setStateFn({ edit: !this.state.edit })}>{this.lbl('edit')}</div>
          </HBox>
          <VBox>
            {this.state.edit ? <CompanyStructureSelection company={company} relation="parent" /> : null}
            {this.company.parentCompanies?.map(c => (
              <HBox className="sub-company" left vCenter key={c.id}>
                <CompanyLabel company={c} />
                <div className="delete" onClick={this.setStateFn({ deleteParentCompany: c })}>
                  <Times />
                </div>
              </HBox>
            ))}
            <HBox left vCenter>
              <ParentToSub />
              <div className="structure-selection current">{company.name}</div>
            </HBox>
            <VBox left vCenter className="sub">
              {this.company.subCompanies?.map(c => (
                <HBox className="sub-company" left key={c.id} vCenter>
                  <ParentToSub />
                  <CompanyLabel company={c} />
                  <div className="delete" onClick={this.setStateFn({ deleteSubCompany: c })}>
                    <Times />
                  </div>
                </HBox>
              ))}
            </VBox>
            {this.state.edit ? <CompanyStructureSelection company={company} relation="child" /> : null}
          </VBox>
          {this.renderDeleteSubCompany()}
          {this.renderDeleteParentCompany()}
        </Container>
      </Card>
    );
  }

  renderDeleteSubCompany() {
    if (!this.state.deleteSubCompany) return null;
    return (
      <Modal title={this.lbl('company.structure.subcompany.delete.confirm.title')}>
        <CompanyLabel company={this.state.deleteSubCompany} />
        <ModalControls>
          <Button primary onClick={() => this.props.deleteSubCompany(this.state.deleteSubCompany.id, this.reset.bind(this))}>
            {this.lbl('ok')}
          </Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  renderDeleteParentCompany() {
    if (!this.state.deleteParentCompany) return null;
    return (
      <Modal title={this.lbl('company.structure.subcompany.delete.confirm.title')}>
        <CompanyLabel company={this.state.deleteParentCompany} />
        <ModalControls>
          <Button
            primary
            onClick={() => this.props.deleteParentCompany(this.state.deleteParentCompany.id, this.reset.bind(this))}
          >
            {this.lbl('ok')}
          </Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }
}

CompanyStructureCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    deleteSubCompany(subCompanyId, callback) {
      let companyId = ownProps.company.id;
      dispatch(deleteSubCompanyFromCompany(companyId, subCompanyId, callback));
    },
    deleteParentCompany(companyId, callback) {
      let parentCompanyId = ownProps.company.id;
      dispatch(deleteParentCompanyFromCompany(companyId, parentCompanyId, callback));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const CompanyStructureCard = compose(
  withConnect,
  withRouter,
)(CompanyStructureCardComp);
